import EmbedFormBlock from './EmbedFormBlock';

export default EmbedFormBlock;